/**
 * Limit x to [min, max]
 */
const clamp = (x: number, min: number, max: number) =>
  Math.min(Math.max(x, min), max);

export default clamp;
